<template>
  <div class="shop-page">
    <div class="filter-bar">
      <div class="search-box">
        <input 
          type="text" 
          v-model="searchKey" 
          placeholder="搜索店家名称、联系人..."
          class="search-input"
        />
        <button @click="search" class="search-btn">搜索</button>
      </div>
      <div class="filter-selects">
        <select v-model="status" class="filter-select">
          <option value="">全部状态</option>
          <option value="1">正常</option>
          <option value="0">禁用</option>
        </select>
        <button @click="showAddModal = true" class="add-btn">+ 添加店家会员</button>
      </div>
    </div>

    <div class="table-container">
      <div v-if="loading" class="loading-state">加载中...</div>
      <table v-else class="shop-table">
        <thead>
          <tr>
            <th>店家ID</th>
            <th>店家名称</th>
            <th>联系人</th>
            <th>手机号</th>
            <th>所在小区</th>
			      <th>物品数</th>
            <th>订单数</th>
            <th>余额</th>
            <th>状态</th>
            <th>店家推广人</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="shop in shops" :key="shop.id">
            <td>{{ shop.id }}</td>
            <td>{{ shop.name }}</td>
            <td>{{ shop.contactName }}</td>
            <td>{{ shop.phone }}</td>
            <td>{{ shop.community }}</td>
			      <td>{{ shop.productCount }}</td>
            <td>{{ shop.orderCount }}</td>
            <td>{{ shop.wallet ? (shop.wallet.balance / 100).toFixed(2) : '0.00' }}</td>
            <td><span :class="'status ' + (shop.status === 1 ? 'status--on' : 'status--off')">{{ shop.status === 1 ? '正常' : '禁用' }}</span></td>
            <td>
              <span
                v-if="shop.referrer"
                class="referrer-cell"
                @click="viewReferrer(shop)"
              >{{ shop.referrer.referrerName }}</span>
              <span v-else class="no-referrer">未关联</span>
            </td>
            <td>
              <button @click="viewDetail(shop.id)" class="action-btn view">查看</button>
              <button @click="editShop(shop.id)" class="action-btn edit">修改</button>
              <button @click="toggleStatus(shop)" class="action-btn" :class="shop.status === 1 ? 'disable' : 'enable'">
                {{ shop.status === 1 ? '禁用' : '启用' }}
              </button>
              <button @click="openAddProductModal(shop)" class="action-btn add-product">添加物品</button>
              <button @click="openAdjustBalance(shop)" class="action-btn balance">编辑余额</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <button :disabled="currentPage === 1 || loading" @click="changePage(currentPage - 1)" class="page-btn">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页</span>
      <button :disabled="currentPage === totalPages || loading" @click="changePage(currentPage + 1)" class="page-btn">下一页</button>
    </div>

    <div v-if="showAddModal" class="modal-overlay" @click.self="closeAddModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>添加店家会员</h3>
          <button @click="closeAddModal" class="close-btn">×</button>
        </div>
        <form @submit.prevent="addShop" class="modal-form">
          <div class="form-item">
            <label>店家会员名称（门头招牌名称） *</label>
            <input 
              type="text" 
              v-model="newShop.name" 
              placeholder="请输入店家会员名称"
              class="form-input"
              required
            />
          </div>
          <div class="form-item">
            <label>关联用户</label>
            <div class="search-select-container">
              <input 
                type="text" 
                v-model="userSearchKey" 
                placeholder="搜索用户..."
                class="search-select-input"
                @click.stop="showUserDropdown = true"
              />
              <div class="search-select-arrow" @click="showUserDropdown = !showUserDropdown">▼</div>
              <div v-if="showUserDropdown" class="search-select-dropdown">
                <div 
                  v-for="user in filteredUsers" 
                  :key="user.id"
                  :class="'dropdown-item' + (newShop.userId === user.id.toString() ? ' selected' : '')"
                  @click="selectUser(user)"
                >
                  {{ user.name }} ({{ user.phone }})
                </div>
                <div v-if="filteredUsers.length === 0" class="dropdown-empty">
                  未找到匹配的用户
                </div>
              </div>
            </div>
            <div v-if="newShop.userId" class="selected-user">
              已选择: {{ getSelectedUserName() }}
            </div>
          </div>
          <div class="form-item">
            <label>联系人姓名 *</label>
            <input 
              type="text" 
              v-model="newShop.contactName" 
              placeholder="请输入联系人姓名"
              class="form-input"
              required
            />
          </div>
          <div class="form-item">
            <label>联系人手机号 *</label>
            <input 
              type="tel" 
              v-model="newShop.phone" 
              placeholder="请输入手机号"
              class="form-input"
              required
            />
          </div>
          <div class="form-item">
            <label>所在小区 *</label>
            <select v-model="newShop.community" class="form-select" required>
              <option value="">请选择小区</option>
              <option v-for="community in communities" :key="community.id" :value="community.name">
                {{ community.name }}
              </option>
            </select>
          </div>
          <div class="form-item">
            <label>详细地址（建议输入格式：栋-单元-门牌号） *</label>
            <input 
              type="text" 
              v-model="newShop.address" 
              placeholder="请输入栋号单元门牌号等"
              class="form-input"
              required
            />
          </div>
          <div class="modal-footer">
            <button type="button" @click="closeAddModal" class="btn-cancel">取消</button>
            <button type="submit" class="btn-submit">确认添加</button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="showAddProductModal" class="modal-overlay" @click.self="closeAddProductModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>添加物品</h3>
          <button @click="closeAddProductModal" class="close-btn">×</button>
        </div>
        <div class="modal-form">
          <div class="form-item">
            <label>所属店家 *</label>
            <input type="text" :value="currentShopName" disabled class="form-input disabled-input" />
          </div>
          <div class="form-item">
            <label>分类</label>
            <select v-model="newProduct.category_id" class="form-select">
              <option :value="0">请选择分类</option>
              <option v-for="cat in categoryOptions" :key="cat.id" :value="cat.id">
                {{ cat.level === 2 ? '└─ ' : '' }}{{ cat.name }}
              </option>
            </select>
          </div>
          <div class="form-item">
            <label>物品名称 *</label>
            <input type="text" v-model="newProduct.name" placeholder="请输入物品名称" class="form-input" />
          </div>
          <div class="form-item">
            <label>参考价格 *</label>
            <input type="number" v-model="newProduct.reference_price" placeholder="请输入价格" step="0.01" class="form-input" />
          </div>
          <div class="form-item">
            <label>规格</label>
            <input type="text" v-model="newProduct.spec" placeholder="如：500g/份" class="form-input" />
          </div>
          <div class="form-item">
            <label>单位</label>
            <input type="text" v-model="newProduct.unit" placeholder="如：份" class="form-input" />
          </div>
          <div class="form-item">
            <label>物品图片</label>
            <input type="text" v-model="newProduct.image" placeholder="请输入图片URL" class="form-input" />
          </div>
          <div class="form-item">
            <label>热门推荐</label>
            <select v-model="newProduct.is_hot" class="form-select">
              <option :value="0">否</option>
              <option :value="1">是</option>
            </select>
          </div>
          <div class="form-item">
            <label>物品描述</label>
            <textarea v-model="newProduct.description" placeholder="请输入物品描述" rows="3" class="form-input"></textarea>
          </div>
          <div class="modal-footer">
            <button type="button" @click="closeAddProductModal" class="btn-cancel">取消</button>
            <button type="button" @click="submitAddProduct" class="btn-submit">确认添加</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑余额弹窗 -->
    <div v-if="showAdjustModal" class="modal-overlay" @click.self="closeAdjustBalance">
      <div class="modal-content">
        <div class="modal-header">
          <h3>编辑余额 - {{ adjustTarget.name }}</h3>
          <button @click="closeAdjustBalance" class="close-btn">×</button>
        </div>
        <div class="modal-form">
          <div class="form-item">
            <label>当前余额（元）</label>
            <div class="form-control-static">{{ adjustTarget.wallet ? (adjustTarget.wallet.balance / 100).toFixed(2) : '0.00' }}</div>
          </div>
          <div class="form-item">
            <label>操作类型</label>
            <div class="radio-group">
              <label class="radio-item">
                <input type="radio" value="recharge" v-model="adjustForm.type" /> 充值
              </label>
              <label class="radio-item">
                <input type="radio" value="deduct" v-model="adjustForm.type" /> 扣除
              </label>
            </div>
          </div>
          <div class="form-item">
            <label>金额（单位：元）</label>
            <input
              type="number"
              min="0.01"
              step="0.01"
              v-model="adjustForm.amount"
              class="form-input"
              placeholder="请输入金额（单位：元）"
            />
          </div>
          <div class="form-item">
            <label>备注</label>
            <textarea
              v-model="adjustForm.description"
              class="form-input"
              placeholder="请输入备注"
              rows="3"
            ></textarea>
          </div>
          <div class="form-item">
            <label>当前操作员</label>
            <input
              type="text"
              :value="currentOperatorName"
              class="form-input disabled-input"
              readonly
            />
          </div>
          <p v-if="adjustError" class="form-error">{{ adjustError }}</p>
          <div class="modal-footer">
            <button type="button" @click="closeAdjustBalance" class="btn-cancel">取消</button>
            <button type="button" class="btn-submit" :disabled="adjustSubmitting" @click="submitAdjustBalance">
              {{ adjustSubmitting ? '提交中...' : '确定' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createShop, getShopList, adjustShopBalance } from '@/api/shops'
import { getCommunityList } from '@/api/communities'
import { getUserList } from '@/api'
import { createProduct } from '@/api/products'
import { getCategoryList } from '@/api/categories'
export default {
  name: 'Shop',
  computed: {
    currentOperatorName() {
      const user = this.$store.state.user.user
      if (!user) return ''
      return user.real_name || user.username || ''
    },
    filteredUsers() {
      if (!this.userSearchKey) {
        return this.users
      }
      const key = this.userSearchKey.toLowerCase()
      return this.users.filter(user => 
        user.name.toLowerCase().includes(key) || 
        user.phone.includes(key)
      )
    }
  },
  data() {
    return {
      searchKey: '',
      status: '',
      currentPage: 1,
      totalPages: 10,
      showAddModal: false,
      showAddProductModal: false,
      currentShopId: '',
      currentShopName: '',
      categoryOptions: [],
      newProduct: {
        name: '',
        shop_id: 0,
        category_id: 0,
        reference_price: '',
        spec: '',
        unit: '',
        image: '',
        is_hot: 0,
        description: ''
      },
      userSearchKey: '',
      showUserDropdown: false,
      loading: false,
      newShop: {
        userId: '',
        name: '',
        contactName: '',
        phone: '',
        community: '',
        address: ''
      },
      users: [],
      communities: [],
      shops: [],
      showAdjustModal: false,
      adjustTarget: {},
      adjustForm: {
        type: 'recharge',
        amount: 0.00,
        description: ''
      },
      adjustSubmitting: false,
      adjustError: ''
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    this.loadShops()
    this.loadCommunities()
    this.loadUsers()
    this.loadCategories()
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    openAddProductModal(shop) {
      this.currentShopId = shop.id
      this.currentShopName = shop.name
      this.newProduct = {
        name: '',
        shop_id: shop.id,
        category_id: 0,
        reference_price: '',
        spec: '',
        unit: '',
        image: '',
        is_hot: 0,
        description: ''
      }
      this.showAddProductModal = true
    },
    closeAddProductModal() {
      this.showAddProductModal = false
    },
    openAdjustBalance(shop) {
      this.adjustTarget = shop
      this.adjustForm = {
        type: 'recharge',
        amount: 0.00,
        description: ''
      }
      this.adjustError = ''
      this.showAdjustModal = true
    },
    closeAdjustBalance() {
      this.showAdjustModal = false
    },
    async submitAdjustBalance() {
      this.adjustError = ''
      const amount = parseFloat(this.adjustForm.amount)
      if (!amount || amount <= 0) {
        this.adjustError = '请输入大于 0 的金额'
        return
      }
      this.adjustSubmitting = true
      try {
        const res = await adjustShopBalance(this.adjustTarget.id, {
          type: this.adjustForm.type,
          // 单位保持「元」，由后端统一转换为「分」后写入
          amount: amount,
          description: this.adjustForm.description
        })
        const newBalance = res && res.data ? res.data.balance : null
        if (newBalance !== null && newBalance !== undefined && this.adjustTarget.wallet) {
          this.adjustTarget.wallet.balance = newBalance
        } else {
          this.loadShops()
        }
        this.showAdjustModal = false
        alert('操作成功')
      } catch (error) {
        this.adjustError = (error.response && error.response.data && error.response.data.message) || '操作失败，请重试'
      } finally {
        this.adjustSubmitting = false
      }
    },
    async loadCategories() {
      try {
        const response = await getCategoryList()
        if (response && response.data) {
          const categories = response.data.data || response.data || []
          this.categoryOptions = Array.isArray(categories) ? categories.filter(cat => cat && cat.id) : []
        }
      } catch (error) {
      }
    },
    async submitAddProduct() {
      if (!this.newProduct.name) {
        alert('请输入物品名称')
        return
      }
      if (!this.newProduct.reference_price) {
        alert('请输入参考价格')
        return
      }
      
      try {
        const productData = {
          shop_id: this.currentShopId,
          name: this.newProduct.name,
          category_id: this.newProduct.category_id || null,
          reference_price: this.newProduct.reference_price,
          spec: this.newProduct.spec || '',
          unit: this.newProduct.unit || '',
          image: this.newProduct.image || '',
          is_hot: this.newProduct.is_hot,
          description: this.newProduct.description || '',
          status: 1
        }
        
        await createProduct(productData)
        alert('添加物品成功')
        this.closeAddProductModal()
      } catch (error) {
        alert('添加物品失败，请稍后重试')
      }
    },
    async loadCommunities() {
      try {
        const response = await getCommunityList()
        
        if (response && response.data) {
          // 兼容两种格式: list(自定义) 或 data(Laravel默认)
          const pageData = response.data
          const communitiesData = pageData.list || pageData.data || []
          
          this.communities = communitiesData.map(community => ({
            id: community.id,
            name: community.name
          }))
        }
      } catch (error) {
      }
    },
    async loadUsers() {
      try {
        const response = await getUserList()
        
        if (response && response.data) {
          // Laravel 分页格式: { current_page, data: [...], total, last_page, ... }
          const pageData = response.data
          const usersData = pageData.data || pageData.list || []
          
          this.users = usersData.map(user => ({
            id: user.id,
            name: user.name || user.nickname || user.username || '',
            phone: user.phone || ''
          }))
        }
      } catch (error) {
      }
    },
    async loadShops() {
      try {
        this.loading = true
        const params = {
          page: this.currentPage,
          pageSize: 10,
          searchKey: this.searchKey,
          status: this.status
        }
        const response = await getShopList(params)
        
        if (response && response.data) {
          // 兼容两种格式: list(自定义) 或 data(Laravel默认)
          const pageData = response.data
          const shopsData = pageData.list || pageData.data || []
          
          this.shops = shopsData.map(shop => ({
            id: shop.id,
            name: shop.name,
            contactName: shop.contact_name,
            phone: shop.phone,
            community: shop.community?.name || '',
            address: shop.address,
            createTime: shop.created_at,
            orderCount: shop.total_orders,
            productCount: shop.products_count,
            status: shop.status,
            referrer: shop.referrer || null,
            wallet: shop.wallet || null
          }))
          
          // 处理分页信息 - 兼容多种格式
          if (pageData.totalPages) {
            this.totalPages = pageData.totalPages
          } else if (pageData.last_page) {
            this.totalPages = pageData.last_page
          } else if (pageData.total) {
            this.totalPages = Math.ceil(pageData.total / params.pageSize)
          } else {
            this.totalPages = 1
          }
        }
      } catch (error) {
        alert('加载店家列表失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleClickOutside(e) {
      if (this.showUserDropdown && !e.target.closest('.search-select-container')) {
        this.showUserDropdown = false
      }
    },
    selectUser(user) {
      this.newShop.userId = user.id.toString()
      this.userSearchKey = ''
      this.showUserDropdown = false
    },
    getSelectedUserName() {
      const user = this.users.find(u => u.id.toString() === this.newShop.userId)
      return user ? `${user.name} (${user.phone})` : ''
    },
    async search() {
      this.currentPage = 1
      await this.loadShops()
    },
    async changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
        await this.loadShops()
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      if (isNaN(date.getTime())) return dateStr
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    viewDetail(id) {
      this.$router.push(`/user/shops/detail/${id}`)
    },
    viewReferrer(shop) {
      if (shop.referrer) {
        this.$router.push({ name: 'shopReferrerDetail', params: { id: shop.referrer.referrerId } })
      }
    },
    editShop(id) {
      this.$router.push(`/user/shops/edit/${id}`)
    },
    toggleStatus(shop) {
        const action = shop.status === 1 ? '禁用' : '启用'
        if (confirm(`确定要${action}店家 ${shop.name} 吗？`)) {
          shop.status = shop.status === 1 ? 0 : 1
          this.loadShops()
        }
      },
      closeAddModal() {
        this.showAddModal = false
        this.newShop = {
          name: '',
          contactName: '',
          phone: '',
          community: '',
          address: ''
        }
      },
      async addShop() {
        try {
          const selectedCommunity = this.communities.find(c => c.name === this.newShop.community)
          
          const newShopData = {
            user_id: this.newShop.userId || null,
            name: this.newShop.name,
            contact_name: this.newShop.contactName,
            phone: this.newShop.phone,
            community_id: selectedCommunity ? selectedCommunity.id : null,
            address: this.newShop.address
          }
          
          const response = await createShop(newShopData)
          
          if (response && response.data) {
            this.closeAddModal()
            await this.loadShops()
            alert('店家添加成功！')
          }
        } catch (error) {
          alert('添加店家失败，请稍后重试')
        }
      }
    }
  }
</script>

<style scoped>
.shop-page {
  padding: 20px;
}

.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.search-box {
  display: flex;
  gap: 10px;
}

.search-input {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  width: 250px;
}

.search-btn {
  padding: 10px 20px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.filter-selects {
  display: flex;
  gap: 15px;
  align-items: center;
}

.filter-select {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

.add-btn {
  padding: 10px 20px;
  background: #2ecc71;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.table-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  overflow: hidden;
}

.loading-state {
  padding: 40px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.shop-table {
  width: 100%;
  border-collapse: collapse;
}

.shop-table th, .shop-table td {
  padding: 14px 16px;
  text-align: left;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.shop-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}

.status {
  padding: 4px 0;
  border-radius: 20px;
  font-size: 12px;
}

.status--on { background: #e8f5e9; color: #2ecc71; }
.status--off { background: #ffebee; color: #e74c3c; }

.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin-right: 5px;
}

.referrer-cell {
  color: #3498db;
  cursor: pointer;
  text-decoration: underline;
}

.referrer-cell:hover {
  color: #217dbb;
}

.no-referrer {
  color: #999;
}

.action-btn.view {
  background: #3498db;
  color: #fff;
}

.action-btn.edit {
  background: #f39c12;
  color: #fff;
}

.action-btn.disable {
  background: #e74c3c;
  color: #fff;
}

.action-btn.enable {
  background: #2ecc71;
  color: #fff;
}

.action-btn.add-product {
  background: #3498db;
  color: #fff;
}

.action-btn.balance {
  background: #f39c12;
  color: #fff;
}

.radio-group {
  display: flex;
  gap: 24px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  cursor: pointer;
}

.form-control-static {
  font-size: 18px;
  font-weight: 600;
  color: #e67e22;
}

.form-error {
  color: #e74c3c;
  font-size: 13px;
  margin: 0 0 8px;
}

.disabled-input {
  background: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  width: 450px;
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  line-height: 1;
}

.modal-form {
  padding: 20px;
}

.form-item {
  margin-bottom: 16px;
}

.form-item label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  color: #333;
}

.form-input, .form-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-input:focus, .form-select:focus {
  outline: none;
  border-color: #3498db;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

.btn-cancel {
  padding: 10px 20px;
  background: #f5f5f5;
  color: #666;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn-submit {
  padding: 10px 20px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.search-select-container {
  position: relative;
  width: 100%;
}

.search-select-input {
  width: 100%;
  padding: 10px 35px 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.search-select-input:focus {
  outline: none;
  border-color: #3498db;
}

.search-select-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 12px;
  cursor: pointer;
}

.search-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}

.dropdown-item {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
}

.dropdown-item:hover {
  background: #f5f7fa;
}

.dropdown-item.selected {
  background: #e8f4fd;
  color: #3498db;
}

.dropdown-empty {
  padding: 15px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.selected-user {
  margin-top: 8px;
  padding: 8px 12px;
  background: #e8f5e9;
  border-radius: 4px;
  font-size: 13px;
  color: #2ecc71;
}
</style>